module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"required_suffix":" (필수)"}}')
  delete Component.options._Ctor
}
